export default __webpack_public_path__ + "static/media/ellipse1.a332eab3.svg";